import axios, { AxiosResponse } from 'axios';
import apiPaths from 'enums/apiPaths';

export interface IPlatba {
    token: string;
    idzadosti: string;
}

export interface IPlatbaData {
    urlbankid: string;
    code?: number;
    message?: string;
}

const platbaApi = (token: string, idzadosti: string) => {
    return axios({
        method: 'POST',
        url: apiPaths.PLATBA,
        headers: {
            Authorization: `Bearer ${token}`
        },
        data: {
            idzadosti
        }
    }).then((resp: AxiosResponse<IPlatbaData>) => resp.data);
};

export default platbaApi;
